import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { SET_ALL_FIELDS_PERMISSIONS_REQUEST } from '../constants/get_group_data.constants';
import { editGroupModulePermissions } from '../../requests/edit_group_module_permissions_request';
import { choose_permissions } from '../../../../../shared/helpers';
import { editGroupModelPermissionsSuccess } from '../actions/edit_group_model_permissions.actions';

function* setAllFieldPermissionSagaRequest({ target: { checked, status } }) {
    const { UserManagement: { User_group_update: { group_id, moduleOptionFields, moduleOption } } } = yield select(); let model; let
        field;

    if (moduleOption !== 'models') {
        const result = [];
        for (model of moduleOptionFields) {
            const { options } = yield call(editGroupModulePermissions, group_id, model.URL, choose_permissions(moduleOption, checked));
            result.push(options);
        }

        if (result.length) {
            yield put(editGroupModelPermissionsSuccess(result));
        } else {
            yield put(editGroupModelPermissionsSuccess('ERROR'));
        }
    } else {
        const option_permissions = {};
        for (model in moduleOptionFields) {
            if (moduleOptionFields.hasOwnProperty(model)) {
                for (field in moduleOptionFields[model].modulesPermissions) {
                    if (moduleOptionFields[model].modulesPermissions.hasOwnProperty(field)) {
                        const { options } = yield call(editGroupModulePermissions, group_id,
                            moduleOptionFields[model].modulesPermissions[field].url,
                            choose_permissions(moduleOption, checked, status ? status[0].toLowerCase() : null));
                        yield put({ type: 'COUNT_LOADING_ITEMS_START' });
                        option_permissions[options.url] = options;
                    }
                }
            }
        }
        if (option_permissions) {
            yield put(editGroupModelPermissionsSuccess(option_permissions, moduleOption));
            yield put({ type: 'COUNT_LOADING_ITEMS_FINISH' });
        } else {
            yield put(editGroupModelPermissionsSuccess('ERROR'));
            yield put({ type: 'COUNT_LOADING_ITEMS_FINISH' });
        }
    }
}

export default function* setAllFieldPermissionSaga() {
    yield takeEvery(SET_ALL_FIELDS_PERMISSIONS_REQUEST, setAllFieldPermissionSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/set_all_field_permission.saga.js